export const TRANSLATIONS = {
    EN: {
        ORGANIZATIONS_SHAREHOLDERS: {
            ALL_SHARES: 'All',
            COMMON_SHARES: 'Normal shares',
            VOTING_SHARES: 'Voting Shares',
            PREFERRED_SHARES: 'Preferred shares',
            CUM_PREFERRED_SHARES: 'Cum preferred shares',
            PRIORITY_SHARES: 'Priority shares',
            LETTER_SHARES: 'Letter shares',
        },
    },
    NL: {
        ORGANIZATIONS_SHAREHOLDERS: {
            ALL_SHARES: 'Alle',
            COMMON_SHARES: 'Gewone aandelen',
            VOTING_SHARES: 'Stemrechtloze aandelen',
            PREFERRED_SHARES: 'Preferente aandelen',
            CUM_PREFERRED_SHARES: 'Cum preferente aandelen',
            PRIORITY_SHARES: 'Prioriteitsaandelen',
            LETTER_SHARES: 'Letter aandelen',
        },
    },
};
